import { render } from "./feedMainPage.vue?vue&type=template&id=44a957b5&scoped=true"
import script from "./feedMainPage.vue?vue&type=script&lang=js"
export * from "./feedMainPage.vue?vue&type=script&lang=js"

import "./feedMainPage.vue?vue&type=style&index=0&id=44a957b5&scoped=true&lang=css"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a957b5"]])

export default __exports__